import { render, staticRenderFns } from "./NewTagModal.vue?vue&type=template&id=2ed36bc2&scoped=true"
import script from "./NewTagModal.vue?vue&type=script&lang=js"
export * from "./NewTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed36bc2",
  null
  
)

export default component.exports